import React from 'react';
import { transformationSteps } from '../data/content';
export function Process() {
  return <section id="process" className="w-full bg-sand py-20 lg:py-28" data-id="element-512" data-mp="1uddafw38xqm9">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-513" data-mp="1ufg72yywmhzy">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-16" data-id="element-514" data-mp="1ygi89lcdt44k">
          <div data-id="element-515" data-mp="23d8p4aw0g3r1">
            <p className="text-sm font-semibold text-sky-600" data-id="element-516" data-mp="23druyt8dz1op">From cracked to resort-worthy</p>
            <h2 className="mt-3 font-display text-3xl font-extrabold leading-tight tracking-tight text-navy-800 sm:text-4xl" data-id="element-517" data-mp="16pc6z1kxd0dp">
              In 3–4 weeks, your pool looks brand new.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-navy-500" data-id="element-518" data-mp="1fnxkgibjhp7m">
              Not just clean — transformed. The plaster is smooth and vibrant, the color is exactly
              what you wanted, the tile gleams, the edges are crisp.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-navy-500" data-id="element-519" data-mp="ryv55h4do8ga">
              Your guests walk into the backyard and their faces light up.{' '}
              <span className="font-semibold text-navy-800" data-id="element-520" data-mp="19kpsqzbc1s6i">
                &ldquo;Wow — when did you do this?&rdquo;
              </span>
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-521" data-mp="10se0d7wnrunw">
              <figure data-id="element-522" data-mp="10qt5tiacgbq1">
                <img src="https://cdn.magicpatterns.com/uploads/a4LbZwntK8HvWwttRJvbmK/aj14.png" alt="A&J crew masking and covering the deck and outdoor kitchen with plastic before starting work" className="h-44 w-full rounded-lg object-cover sm:h-40" data-id="element-523" data-mp="vu2raze6to6q" />
                <figcaption className="mt-2.5 text-[13px] leading-snug text-navy-400" data-id="element-524" data-mp="lu3kp81bw7wi">
                  Deck, coping, and outdoor kitchen covered before a single bag is opened.
                </figcaption>
              </figure>
              <figure data-id="element-525" data-mp="cxbd34di5z9j">
                <img src="https://cdn.magicpatterns.com/uploads/cHo2uayf5LYW8egyjbtcqW/aj13.png" alt="A&J crew troweling fresh white plaster inside a drained backyard pool on a sunny day" className="h-44 w-full rounded-lg object-cover sm:h-40" data-id="element-526" data-mp="2c8m7lmn1bu5w" />
                <figcaption className="mt-2.5 text-[13px] leading-snug text-navy-400" data-id="element-527" data-mp="2qc1kzfjx25r4">
                  Our own crew troweling the finish coat — no subcontractors.
                </figcaption>
              </figure>
            </div>
          </div>

          <ol className="relative" data-id="element-528" data-mp="2mbrg667v1ldu">
            {transformationSteps.map((item, index) => <li key={item.step} className="relative flex gap-6 pb-10 last:pb-0" data-id="element-529" data-mp="2m9n8dd6uc28a" data-mpi={index}>
                {index < transformationSteps.length - 1 && <span aria-hidden="true" className="absolute left-[19px] top-11 h-[calc(100%-2.75rem)] w-px bg-navy-200" data-id="element-530" data-mp="3e3p7lla5aunl" />}
                <span className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy-800 font-display text-sm font-bold text-white" data-id="element-531" data-mp="302mj71voh89i">
                  {index + 1}
                </span>
                <div className="pt-1" data-id="element-532" data-mp="1omxv276ou374">
                  <p className="text-xs font-bold uppercase tracking-[0.16em] text-sky-600" data-id="element-533" data-mp="1tn2g8aijjm3o">
                    {item.step}
                  </p>
                  <h3 className="mt-1.5 font-display text-xl font-bold text-navy-800" data-id="element-534" data-mp="1m29n2gp66u83">
                    {item.title}
                  </h3>
                  <p className="mt-2 max-w-xl text-[15px] leading-relaxed text-navy-400" data-id="element-535" data-mp="1v4iv8zwyubib">
                    {item.body}
                  </p>
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}